import { render, staticRenderFns } from "./AddTenants.vue?vue&type=template&id=2df00e3e&scoped=true&"
import script from "./AddTenants.vue?vue&type=script&lang=js&"
export * from "./AddTenants.vue?vue&type=script&lang=js&"
import style0 from "./AddTenants.vue?vue&type=style&index=0&id=2df00e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df00e3e",
  null
  
)

export default component.exports